import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { EPaymentConstant } from "../../../../../../../../../dependencies/getContent/constants";
import { processTrailingCases } from "../../../../../../../../../utils/utils";
import { findFirst } from "../../../../../../../../../../utils/arrays";
import { templateParser } from "../../../../../../../../../../utils/strings";
var INVALID_SYMBOLS = /[^0-9,.]/g;
var INPUT_DELIMITER = '.';
var OUTPUT_DELIMITER = ',';
export var unformatValue = function unformatValue(value) {
  if (!value) return undefined;

  /** Удалить недопустимые символы, заменить ',' на '.' для удобства форматирования */
  return value //
  .replace(INVALID_SYMBOLS, '') // remove invalid symbols
  .replace(RegExp(OUTPUT_DELIMITER, 'g'), INPUT_DELIMITER) // replace "," with "."
  .split(INPUT_DELIMITER) // split based on "."
  .slice(0, 2) // make sure there only 2 parts
  .map(function (v, i) {
    // make sure part 2 has only 2 numbers
    if (i !== 1) return v;
    return v.substring(0, 2);
  }).join(INPUT_DELIMITER);
};
export var formatValue = function formatValue(value) {
  if (!value) return '';
  return value.replace(INVALID_SYMBOLS, '').split(INPUT_DELIMITER).map(function (v, i) {
    if (i === 1) return v;
    return Number(v).toLocaleString('ru-RU');
  }).join(OUTPUT_DELIMITER);
};
export var validateInput = function validateInput(_ref) {
  var value = _ref.value,
    texts = _ref.texts,
    _ref$bounds = _slicedToArray(_ref.bounds, 2),
    min = _ref$bounds[0],
    max = _ref$bounds[1];
  var num = Number(unformatValue(value));
  if (!num) return texts.empty;
  var numInKopeikas = rublesToKopeiki(num);
  return findFirst([numInKopeikas < min && templateParser(texts.min, {
    min: kopeikiToRubles(min)
  }), numInKopeikas > max && templateParser(texts.max, {
    max: kopeikiToRubles(max)
  })]);
};
export var rublesToKopeiki = function rublesToKopeiki(rubles) {
  return rubles * EPaymentConstant.KopeikiPerRuble;
};
export var kopeikiToRubles = function kopeikiToRubles(kopeiki) {
  var rubles = kopeiki / EPaymentConstant.KopeikiPerRuble;
  return formatValue(unformatValue(processTrailingCases("".concat(rubles))));
};